<section class="py-5 bg-primary text-primary-foreground">
  <div class="container">
    <ul class="breadcrumbs">
      <li class="text-primary-foreground opacity-60p"><a [routerLink]="''">Home</a></li>
      <li class="text-primary-foreground">Report Inconsistency</li>
    </ul>
  </div>

  <div class="container pt-3 pb-2">
    <h1 class="fs-40 fw-bold heading-font text-uppercase">REPORTING INCONSISTENT INFORMATION PERSONS WITH SIGNIFICANT CONTROL (PSC) REGISTER</h1>
    <p class="mt-3 opacity-60p line-height-180p">Help maintain the integrity of Nigeria's Corporate Directory. Use this official portal to safely report discrepancies or errors spotted on verified Persons with Significant Control (PSC) profiles.</p>
  </div>
</section>
<section class="psc-details-section container py-5">
  <form [formGroup]="form" class="d-flex flex-column gap-3 py-3">
    <div class="card">
      <div class="d-flex align-items-center gap-2 mb-3">
        <span class="number-indicator me-1">1</span>
        <h2 class="card-title fs-20">Details of Reporting Organization</h2>
      </div>

      <div class="row g-3">
        <div class="col-md-12">
          <div class="form-group">
            <label class="form-label">Name of Reporting Organization / Individual</label>
            <input
              class="form-control"
              type="text"
              placeholder="e.g. Aliyu Ibrahim & Co. Partners"
              [formControlName]="'reportingName'"
              [ngClass]="{'error': hasError('reportingName')}"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-label">Reporting Organization / Individual Phone Number </label>
            <input
              class="form-control"
              type="tel"
              placeholder="eg: +234 809 555 0000"
              [formControlName]="'reportingPhoneNumber'"
              [ngClass]="{'error': hasError('reportingPhoneNumber')}"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-label">Email Reporting Organization / Individual </label>
            <input
              class="form-control"
              type="email"
              placeholder="e.g. contact@aliyuandpartners.com"
              [formControlName]="'reportingEmail'"
              [ngClass]="{'error': hasError('reportingEmail')}"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="d-flex align-items-center gap-2 mb-3">
        <span class="number-indicator me-1">2</span>
        <h2 class="card-title fs-20">Details Of The Company/LLP To Be Reported For Inconsistent Information</h2>
      </div>

      <div class="row g-3">
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-label">Company / LLP Name</label>
            <input
              class="form-control"
              type="text"
              placeholder="e.g. Max Tech Company Limited"
              [formControlName]="'companyName'"
              [ngClass]="{'error': hasError('companyName')}"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-label">Company / LLP Registration Number </label>
            <div class="input-group" [ngClass]="{'error': hasError('companyRegistrationNumber')}">
              <span class="input-group-text pe-2">RC</span>
              <input
                class="form-control"
                type="text"
                placeholder="e.g. 110492"
                [formControlName]="'companyRegistrationNumber'"
              />
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-label optional">Company / LLP Email Address</label>
            <input
              class="form-control"
              type="text"
              placeholder="e.g. info@company.com"
              [formControlName]="'companyEmailAddress'"
              [ngClass]="{'error': hasError('companyEmailAddress')}"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-label optional">Company / LLP Phone Number</label>
            <input
              class="form-control"
              type="text"
              placeholder="eg: +234 708 062 9000"
              [formControlName]="'companyPhoneNumber'"
              [ngClass]="{'error': hasError('companyPhoneNumber')}"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="d-flex align-items-center gap-2 mb-3">
        <span class="number-indicator me-1">3</span>
        <h2 class="card-title fs-20">Nature of Inconsistent Information</h2>
      </div>

      <div class="row g-3">
        <div class="col-md-12">
          <div class="row rounded pb-2 g-3" [ngClass]="{'border border-danger': hasError('natureOfInconsistentInformation')}">
            <div class="col-sm-6">
              <label class="check-input w-100">
                <input type="radio" [formControlName]="'natureOfInconsistentInformation'" [value]="'INCOMPLETE_INFORMATION'" />
                <span class="text-content">Incomplete Information</span>
                <span class="radio-icon"><span class="active-indicator"></span></span>
              </label>
            </div>
            <div class="col-sm-6">
              <label class="check-input w-100">
                <input type="radio" [formControlName]="'natureOfInconsistentInformation'" [value]="'UNAVAILABLE_INFORMATION'" />
                <span class="text-content">Unavailable Information</span>
                <span class="radio-icon"><span class="active-indicator"></span></span>
              </label>
            </div>
            <div class="col-sm-6">
              <label class="check-input w-100">
                <input type="radio" [formControlName]="'natureOfInconsistentInformation'" [value]="'DISCREPANCY_OF_INFORMATION'" />
                <span class="text-content">Discrepancy of Information</span>
                <span class="radio-icon"><span class="active-indicator"></span></span>
              </label>
            </div>
            <div class="col-sm-6">
              <label class="check-input w-100">
                <input type="radio" [formControlName]="'natureOfInconsistentInformation'" [value]="'OTHER'" />
                <span class="text-content">Other (Please specify)</span>
                <span class="radio-icon"><span class="active-indicator"></span></span>
              </label>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label class="form-label optional">If other, please specify in detail</label>
            <textarea
              class="form-control"
              placeholder="Write down the specific structural or custom inconsistency spotted..."
              [formControlName]="'otherNatureDetail'"
              [ngClass]="{'error': hasError('otherNatureDetail')}"
            ></textarea>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="d-flex align-items-center gap-2 mb-3">
        <span class="number-indicator me-1">4</span>
        <h2 class="card-title fs-20">Details Of Inconsistent Information</h2>
      </div>

      <div class="row g-3">
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-label">Last Name of the PSC</label>
            <input
              class="form-control"
              type="text"
              placeholder="e.g. Adebayo"
              [formControlName]="'pscLastName'"
              [ngClass]="{'error': hasError('pscLastName')}"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-label">First Name of the PSC</label>
            <input
              class="form-control"
              type="text"
              placeholder="e.g. Sarah"
              [formControlName]="'pscFirstName'"
              [ngClass]="{'error': hasError('pscFirstName')}"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-label optional">Other Names of the PSC</label>
            <input
              class="form-control"
              type="text"
              placeholder="e.g. Chioma"
              [formControlName]="'pscOtherNames'"
              [ngClass]="{'error': hasError('pscOtherNames')}"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-label">Nationality of the PSC</label>
            <select
              class="form-control"
              [formControlName]="'pscNationality'"
              [ngClass]="{'error': hasError('pscNationality')}"
            >
              <option value="">-- Select Nationality --</option>
              @for (n of NationalitiesList; track n.id) {
                <option value="{{n.name}}">{{ n.name }}</option>
              }
            </select>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-label">Date of Birth (PSC)</label>
            <input
              class="form-control"
              type="date" max="21/08/2026"
              [formControlName]="'pscDateOfBirth'"
              [max]="maxDOB"
              [ngClass]="{'error': hasError('pscDateOfBirth')}"
            />
          </div>
        </div>
        <div class="col-md-12" [ngClass]="{'border border-danger': hasError('pscIdentityDocumentType')}">
          <div class="form-group">
            <label class="form-label">PSC Verified Identity Document Type</label>
            <div class="d-flex flex-wrap gap-2 white-space-nowrap">
              <label class="check-input">
                <input type="radio" [formControlName]="'pscIdentityDocumentType'" value="NIN" />
                <span class="text-content">National Identification Number (NIN)</span>
                <span class="radio-icon"><span class="active-indicator"></span></span>
              </label>
              <label class="check-input">
                <input type="radio" [formControlName]="'pscIdentityDocumentType'" value="INTERNATIONAL_PASSPORT" />
                <span class="text-content">International Passport</span>
                <span class="radio-icon"><span class="active-indicator"></span></span>
              </label>
              <label class="check-input">
                <input type="radio" [formControlName]="'pscIdentityDocumentType'" value="DRIVERS_LICENCE" />
                <span class="text-content">Driver's Licence</span>
                <span class="radio-icon"><span class="active-indicator"></span></span>
              </label>
              <label class="check-input">
                <input type="radio" [formControlName]="'pscIdentityDocumentType'" value="VOTERS_CARD" />
                <span class="text-content">Voter's Card</span>
                <span class="radio-icon"><span class="active-indicator"></span></span>
              </label>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label class="form-label optional">Any Additional Comments?</label>
            <textarea
              class="form-control"
              placeholder="Provide any other necessary context, supporting document references, or explanations regarding the requested correction..."
              [formControlName]="'additionalComments'"
              [ngClass]="{'error': hasError('additionalComments')}"
            ></textarea>
          </div>
        </div>
      </div>
    </div>

    <div class="card d-flex gap-3 text-primary py-3">
      <span><iconify [size]="20" [name]="'lucide:shield-alert'" /></span>
      <span class="fs-14">This official report submission is protected under the CAMA 2020 Data Integrity Protocols. All reported discrepancies are securely processed and investigated by registry officers. Intentional submission of false claims is subject to administrative sanctions.</span>
    </div>

    <div class="text-end pt-3">
      <button [disabled]="working()" class="btn btn-success" (click)="sendReport()">
        @if (working()) {
          <loading-icon />
        } @else {
          <iconify [name]="'lucide:send'" />
        }
        Submit Official Report
      </button>
    </div>
  </form>
</section>
